module.exports = __webpack_public_path__ + "media/images/covid/logo_mobile-0d4ce2c2a2281ef484539d76029075ae.png";